import { SignupParams } from '@/dtos/auth.dto';
import { Storage } from '@capacitor/storage';

export const capacitorStorageService = {
	// Make sure what's being stored is an object
	setItem: async (key: string, value: object) => {
		await Storage.set({
			key,
			value: JSON.stringify(value),
		});
	},

	getItem: async (key: string) => {
		const { value } = await Storage.get({ key });
		if (!value) return null;
		return JSON.parse(value);
	},

	removeItem: async (key: string) => {
		await Storage.remove({ key });
	},

	setSignupParams: async (obj: SignupParams) => {
		const key = 'signupParams';
		const value = { ...obj, time: new Date().getTime() };
		capacitorStorageService.setItem(key, value);
	},

	getAndRemoveSignupParams: async (): Promise<SignupParams> => {
		const key = 'signupParams';
		let obj = {};

		const result = await capacitorStorageService.getItem(key);
		if (result) {
			if (new Date().getTime() - result.time < 1000 * 60 * 5) obj = result;
		}

		capacitorStorageService.removeItem(key);
		return obj;
	},
};
